import React from 'react';
import { Award, Briefcase, GraduationCap } from 'lucide-react';

const LeadershipCard = ({ member }) => {
  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-xl transition-all duration-300 hover:shadow-2xl hover:-translate-y-2">
      {/* Image Container - Fixed aspect ratio */}
      <div className="aspect-square overflow-hidden bg-gray-100">
        <img
          src={member.image}
          alt={member.name}
          className="w-full h-full object-cover object-[center_20%] hover:scale-110 transition-transform duration-500"
        />
      </div>
      
      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-primary-blue mb-1">{member.name}</h3>
        <p className="text-gold font-semibold mb-3">{member.designation}</p>
        
        <div className="space-y-2">
          <div className="flex items-center text-dark-gray text-sm">
            <GraduationCap className="w-4 h-4 text-gold mr-2 flex-shrink-0" />
            <span>{member.qualification}</span>
          </div>
          <div className="flex items-center text-dark-gray text-sm">
            <Briefcase className="w-4 h-4 text-gold mr-2 flex-shrink-0" />
            <span>{member.experience}</span>
          </div>
          <div className="flex items-center text-dark-gray text-sm">
            <Award className="w-4 h-4 text-gold mr-2 flex-shrink-0" />
            <span>{member.specialization}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadershipCard;